@if (isNavigating || isLoading) {
    <div class="tw-fixed tw-inset-0 tw-z-[9999] tw-cursor-wait tw-bg-transparent"></div>
}

<div class="tw-h-full"
    [class.tw-pointer-events-none]="isNavigating || isLoading">
    @if(modulePath){
        <div class="tw-h-full">
            <app-items-module-tabs (tabPanelChange)="changeTab($event)" [getTabChange]="tabChange">
                <ng-container Products [ngTemplateOutlet]="products" ></ng-container>
                <ng-container Categories [ngTemplateOutlet]="categories"></ng-container>
                <ng-container Components [ngTemplateOutlet]="components"></ng-container>
                <ng-container RawMaterials [ngTemplateOutlet]="raw_materials"></ng-container>
                <ng-container Departments [ngTemplateOutlet]="departments"></ng-container>
                <ng-container VatRate [ngTemplateOutlet]="vat_rate"></ng-container>
            </app-items-module-tabs>
        </div>
    }
    @else {
        <div appUpgradeUiView></div>
    }
</div>


<ng-template #products>
    @if (tabActive === 'items') {
        <app-items-showcase />
    }
</ng-template>

<ng-template #categories>
    @if (tabActive === 'categories') {
        <app-categories-showcase 
            [printers]="printers"
        />
    }
</ng-template>

<ng-template #components>
    @if (tabActive === 'components') {
        <app-components-showcase />
    }
</ng-template>

<ng-template #raw_materials>
    @if (tabActive === 'raw-materials') {
        <app-raw-materials-showcase />
    }
</ng-template>

<ng-template #departments>
    @if (tabActive === 'departments') {
        <app-departments-showcase 
        [giftcardsTypes]="giftcardsTypes" 
        />
    }
</ng-template>

<ng-template #vat_rate>
    @if (tabActive === 'vat_rates') {
        <app-vat-rates-showcase />
    }
</ng-template>
